export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  longDescription: string;
  posterUrl: string;
  backdropUrl: string;
  tags: string[];
  isNew: boolean;
  isHot: boolean;
  isFeatured: boolean;
  views: number;
}

export const categories = [
  { name: "动作片", slug: "action", icon: "ri-sword-line", description: "热血激战，燃爆全场" },
  { name: "喜剧片", slug: "comedy", icon: "ri-emotion-laugh-line", description: "笑料不断，欢乐无限" },
  { name: "科幻片", slug: "scifi", icon: "ri-rocket-line", description: "未来世界，无限想象" },
  { name: "爱情片", slug: "romance", icon: "ri-heart-line", description: "甜蜜心动，感人至深" },
  { name: "恐怖片", slug: "horror", icon: "ri-ghost-line", description: "惊悚刺激，毛骨悚然" },
  { name: "剧情片", slug: "drama", icon: "ri-film-line", description: "人生百态，深入人心" },
  { name: "动画片", slug: "animation", icon: "ri-palette-line", description: "童趣盎然，老少皆宜" },
  { name: "纪录片", slug: "documentary", icon: "ri-camera-line", description: "真实记录，探索世界" },
];

export const movies: Movie[] = [
  {
    id: "movie-1",
    title: "战狼3：终极使命",
    titleEn: "Wolf Warrior 3: Final Mission",
    category: "动作片",
    categorySlug: "action",
    year: 2026,
    rating: 9.2,
    duration: "128分钟",
    region: "中国大陆",
    director: "吴京",
    actors: ["吴京", "张译", "李晨", "余男"],
    description: "冷锋再次被卷入一场国际危机，为了守护和平，他毅然踏上征程。",
    longDescription: "《战狼3：终极使命》延续了战狼系列的热血风格，讲述了退役军人冷锋在海外执行任务时，意外发现一个危及全球安全的惊天阴谋。面对强大的敌人和重重困难，冷锋凭借过人的军事素养和不屈的意志，与队友们并肩作战，最终成功阻止了灾难的发生。影片在动作场面上再度升级，海陆空三线作战的宏大场面令人血脉贲张。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%2C%20soldier%20in%20tactical%20gear%20standing%20heroically%20with%20explosion%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20movie%20poster%20style&width=400&height=560&seq=movie-poster-1&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Epic%20action%20movie%20backdrop%2C%20military%20soldiers%20in%20combat%20scene%2C%20dramatic%20sky%20with%20explosions%2C%20cinematic%20wide%20shot%2C%20intense%20warm%20lighting%2C%20golden%20hour%20atmosphere%2C%20high%20production%20value&width=1600&height=700&seq=movie-backdrop-1&orientation=landscape",
    tags: ["动作", "军事", "热血"],
    isNew: true,
    isHot: true,
    isFeatured: true,
    views: 1258000,
  },
  {
    id: "movie-2",
    title: "夏洛特烦恼2：重返青春",
    titleEn: "Goodbye Mr. Loser 2: Back to Youth",
    category: "喜剧片",
    categorySlug: "comedy",
    year: 2026,
    rating: 8.9,
    duration: "115分钟",
    region: "中国大陆",
    director: "闫非",
    actors: ["沈腾", "马丽", "艾伦", "常远"],
    description: "夏洛再次穿越回到高中时代，这一次他要改写所有人的人生轨迹。",
    longDescription: "《夏洛特烦恼2：重返青春》是开心麻花团队的又一力作。故事接续前作，夏洛在一次意外中再次穿越回到高中时代，但这一次他发现自己身处一个平行世界。为了找到回家的路，他不得不重新经历青春期的酸甜苦辣，同时还要应对各种啼笑皆非的乌龙事件。沈腾和马丽的黄金搭档再次为观众带来爆笑体验。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20funny%20expressions%20of%20middle-aged%20man%20in%20school%20uniform%2C%20bright%20and%20cheerful%20colors%2C%20warm%20yellow%20and%20orange%20tones%2C%20playful%20and%20humorous%20movie%20poster%20style%2C%20clean%20background&width=400&height=560&seq=movie-poster-2&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Bright%20comedy%20movie%20backdrop%2C%20high%20school%20classroom%20scene%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20cheerful%20atmosphere%2C%20nostalgic%20Chinese%20school%20setting%2C%20soft%20golden%20lighting%2C%20light%20and%20airy%20mood&width=1600&height=700&seq=movie-backdrop-2&orientation=landscape",
    tags: ["喜剧", "青春", "穿越"],
    isNew: true,
    isHot: true,
    isFeatured: false,
    views: 987000,
  },
  {
    id: "movie-3",
    title: "星际穿越2：新家园",
    titleEn: "Interstellar 2: New Home",
    category: "科幻片",
    categorySlug: "scifi",
    year: 2026,
    rating: 9.4,
    duration: "156分钟",
    region: "美国",
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "蒂莫西·柴勒梅德"],
    description: "人类终于抵达了新星球，但等待他们的却是前所未有的挑战。",
    longDescription: "《星际穿越2：新家园》由克里斯托弗·诺兰执导，是经典科幻片《星际穿越》的续作。故事发生在库珀抵达新星球之后的数年，人类殖民者发现这个看似完美的星球隐藏着致命的秘密。影片延续了诺兰一贯的烧脑风格，在宏大的宇宙背景下探讨人性、时间和爱的永恒主题。视觉效果震撼，IMAX摄影机拍摄的太空场景令人叹为观止。",
    posterUrl: "https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%2C%20astronaut%20standing%20on%20alien%20planet%20surface%2C%20massive%20ringed%20planet%20in%20the%20sky%2C%20deep%20space%20black%20background%20with%20stars%2C%20ethereal%20nebula%20glow%2C%20cinematic%20sci-fi%20atmosphere%2C%20minimalist%20composition&width=400&height=560&seq=movie-poster-3&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20backdrop%2C%20alien%20landscape%20with%20twin%20suns%20setting%2C%20vast%20desert%20plains%20with%20strange%20rock%20formations%2C%20deep%20space%20sky%20with%20galaxies%20visible%2C%20cinematic%20wide%20shot%2C%20atmospheric%20and%20mysterious%20lighting&width=1600&height=700&seq=movie-backdrop-3&orientation=landscape",
    tags: ["科幻", "太空", "冒险"],
    isNew: true,
    isHot: true,
    isFeatured: true,
    views: 2100000,
  },
  {
    id: "movie-4",
    title: "那些年，我们一起追的女孩2",
    titleEn: "You Are the Apple of My Eye 2",
    category: "爱情片",
    categorySlug: "romance",
    year: 2026,
    rating: 8.5,
    duration: "108分钟",
    region: "中国台湾",
    director: "九把刀",
    actors: ["柯震东", "陈妍希", "王大陆"],
    description: "十年后的重逢，曾经的那些人，那些事，依然刻骨铭心。",
    longDescription: "《那些年，我们一起追的女孩2》讲述了柯景腾和沈佳宜在大学毕业十年后的故事。分别多年的两人在一次同学会上重逢，往昔的回忆如潮水般涌来。曾经的青涩与遗憾，如今化作了成熟的感悟与释怀。影片以细腻的笔触描绘了成长的代价与爱情的真谛，那些关于青春的记忆永远是最美的风景。",
    posterUrl: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20movie%20poster%2C%20young%20couple%20sitting%20on%20a%20bench%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20golden%20lighting%2C%20dreamy%20bokeh%20effect%2C%20nostalgic%20and%20tender%20atmosphere%2C%20clean%20and%20elegant%20composition&width=400&height=560&seq=movie-poster-4&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Romantic%20movie%20backdrop%2C%20cherry%20blossom%20avenue%20in%20full%20bloom%2C%20soft%20golden%20hour%20sunlight%20filtering%20through%20petals%2C%20dreamy%20and%20nostalgic%20atmosphere%2C%20warm%20pink%20and%20golden%20tones%2C%20shallow%20depth%20of%20field%2C%20cinematic%20look&width=1600&height=700&seq=movie-backdrop-4&orientation=landscape",
    tags: ["爱情", "青春", "回忆"],
    isNew: false,
    isHot: true,
    isFeatured: false,
    views: 756000,
  },
  {
    id: "movie-5",
    title: "午夜凶铃：轮回",
    titleEn: "The Ring: Reincarnation",
    category: "恐怖片",
    categorySlug: "horror",
    year: 2026,
    rating: 8.3,
    duration: "102分钟",
    region: "日本",
    director: "中田秀夫",
    actors: ["松岛菜菜子", "佐藤健", "桥本爱"],
    description: "诅咒录像带再次出现，这一次背后的真相更加骇人听闻。",
    longDescription: "《午夜凶铃：轮回》是日本经典恐怖片《午夜凶铃》系列的最新续作。故事发生在贞子事件结束二十年后，一盘新的诅咒录像带再次出现在东京。年轻的新闻记者在调查过程中，逐渐揭开了一个比贞子更加古老的诅咒之谜。影片将日式心理恐怖的氛围营造推向极致，每一个镜头都让人不寒而栗。",
    posterUrl: "https://readdy.ai/api/search-image?query=Japanese%20horror%20movie%20poster%2C%20eerie%20dark%20well%20in%20misty%20forest%2C%20pale%20fog%20surrounding%2C%20cold%20blue%20and%20dark%20grey%20tones%2C%20minimalist%20and%20unsettling%20composition%2C%20Japanese%20text%20styling%2C%20creepy%20atmosphere&width=400&height=560&seq=movie-poster-5&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Horror%20movie%20backdrop%2C%20abandoned%20Japanese%20house%20in%20dark%20forest%2C%20full%20moon%20casting%20eerie%20shadows%2C%20cold%20blue%20moonlight%2C%20fog%20and%20mist%2C%20creepy%20atmospheric%20wide%20shot%2C%20unsettling%20and%20mysterious%20mood&width=1600&height=700&seq=movie-backdrop-5&orientation=landscape",
    tags: ["恐怖", "惊悚", "悬疑"],
    isNew: false,
    isHot: false,
    isFeatured: false,
    views: 523000,
  },
  {
    id: "movie-6",
    title: "无名之辈2：小人物",
    titleEn: "A Cool Fish 2: Nobody",
    category: "剧情片",
    categorySlug: "drama",
    year: 2026,
    rating: 9.0,
    duration: "118分钟",
    region: "中国大陆",
    director: "饶晓志",
    actors: ["陈建斌", "任素汐", "章宇", "王砚辉"],
    description: "一群社会底层的小人物，为了尊严和希望，上演了一场笑中带泪的故事。",
    longDescription: "《无名之辈2：小人物》延续了前作的黑色幽默风格，讲述了一群生活在城市边缘的小人物，在命运的捉弄下阴差阳错地走到了一起。他们中有失业的中年工人、被生活压垮的单亲妈妈、怀才不遇的街头艺人。每个人都有自己的故事和伤痛，但在彼此的陪伴中，他们找到了继续前行的勇气。影片以荒诞喜剧的外壳包裹着温情的内核，让人在笑声中感受到生活的温度。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%2C%20group%20of%20ordinary%20people%20standing%20together%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20golden%20lighting%2C%20realistic%20and%20grounded%20style%2C%20emotional%20and%20humanistic%20atmosphere%2C%20urban%20landscape%20background&width=400&height=560&seq=movie-poster-6&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20backdrop%2C%20narrow%20alley%20in%20old%20city%20district%20at%20golden%20hour%2C%20warm%20sunlight%20with%20long%20shadows%2C%20everyday%20life%20scene%2C%20laundry%20hanging%20between%20buildings%2C%20realistic%20slice%20of%20life%20atmosphere%2C%20cinematic%20composition&width=1600&height=700&seq=movie-backdrop-6&orientation=landscape",
    tags: ["剧情", "黑色幽默", "社会"],
    isNew: false,
    isHot: true,
    isFeatured: true,
    views: 689000,
  },
  {
    id: "movie-7",
    title: "哪吒之魔童降世2：封神之战",
    titleEn: "Ne Zha 2: The Battle of Gods",
    category: "动画片",
    categorySlug: "animation",
    year: 2026,
    rating: 9.5,
    duration: "135分钟",
    region: "中国大陆",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    description: "哪吒与敖丙联手对抗天命，一场震撼天地的封神之战拉开序幕。",
    longDescription: "《哪吒之魔童降世2：封神之战》是国产动画电影里程碑《哪吒之魔童降世》的续作。故事承接前作，哪吒在经历了天劫之后，与敖丙一同踏上了封神之路。古老的封神榜重现人间，三界众生蠢蠢欲动。哪吒必须在命运的洪流中找到自己的位置，守护他所珍视的一切。影片在视觉效果上达到了国产动画的新高度，中国风的美术设计和惊艳的特效场面令人叹为观止。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20young%20mythical%20hero%20with%20fire%20elements%20floating%20in%20dramatic%20pose%2C%20traditional%20Chinese%20art%20style%20with%20modern%20animation%20aesthetics%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20fantasy%20atmosphere%2C%20flames%20and%20clouds%20swirling&width=400&height=560&seq=movie-poster-7&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20backdrop%2C%20ancient%20Chinese%20heavenly%20palace%20in%20clouds%2C%20golden%20dragons%20flying%20through%20vibrant%20orange%20and%20red%20sky%2C%20traditional%20Chinese%20mythological%20art%20style%2C%20grand%20scale%2C%20dramatic%20and%20majestic%20atmosphere&width=1600&height=700&seq=movie-backdrop-7&orientation=landscape",
    tags: ["动画", "神话", "奇幻"],
    isNew: true,
    isHot: true,
    isFeatured: true,
    views: 3500000,
  },
  {
    id: "movie-8",
    title: "地球脉动3：生命奇迹",
    titleEn: "Planet Earth 3: Miracle of Life",
    category: "纪录片",
    categorySlug: "documentary",
    year: 2026,
    rating: 9.7,
    duration: "98分钟",
    region: "英国",
    director: "大卫·爱登堡",
    actors: ["大卫·爱登堡"],
    description: "穿越七大洲四大洋，见证地球上最壮观的生命奇迹。",
    longDescription: "《地球脉动3：生命奇迹》由BBC自然历史部耗时五年打造，大卫·爱登堡爵士亲自解说。影片采用最先进的4K HDR拍摄技术，从南极冰川到非洲草原，从深海世界到热带雨林，以前所未有的视角展现了地球上最不可思议的生命形态。每一帧画面都是大自然的艺术品，每一个生命故事都令人动容。这不仅是一部纪录片，更是对地球生命的深情礼赞。",
    posterUrl: "https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%2C%20majestic%20polar%20bear%20standing%20on%20arctic%20ice%20with%20aurora%20borealis%20in%20the%20sky%2C%20crystal%20clear%20icy%20blue%20tones%2C%20breathtaking%20natural%20beauty%2C%20minimalist%20and%20elegant%20composition%2C%20National%20Geographic%20style%20photography&width=400&height=560&seq=movie-poster-8&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Nature%20documentary%20backdrop%2C%20vast%20African%20savanna%20at%20golden%20hour%2C%20herds%20of%20wildebeest%20migrating%20across%20plains%2C%20dramatic%20cloud%20formations%2C%20warm%20earth%20tones%2C%20epic%20scale%2C%20stunning%20natural%20lighting%2C%20cinematic%20documentary%20style&width=1600&height=700&seq=movie-backdrop-8&orientation=landscape",
    tags: ["纪录片", "自然", "动物"],
    isNew: false,
    isHot: false,
    isFeatured: false,
    views: 456000,
  },
  {
    id: "movie-9",
    title: "速度与激情11：终局之战",
    titleEn: "Fast & Furious 11: Endgame",
    category: "动作片",
    categorySlug: "action",
    year: 2026,
    rating: 8.7,
    duration: "142分钟",
    region: "美国",
    director: "路易斯·莱特里尔",
    actors: ["范·迪塞尔", "杰森·斯坦森", "道恩·强森", "米歇尔·罗德里格兹"],
    description: "家族最后的集结，为了自由与正义，他们将展开终极对决。",
    longDescription: "《速度与激情11：终局之战》为速度与激情系列画上了完美的句号。唐老大和他的家族面临着史上最强大的敌人——一个掌控全球地下势力的神秘组织。从洛杉矶街头到迪拜沙漠，从东京霓虹到里约贫民窟，家族的足迹遍布全球。惊天动地的飙车场面和拳拳到肉的近身格斗，将为观众带来极致的视听盛宴。",
    posterUrl: "https://readdy.ai/api/search-image?query=Action%20movie%20poster%2C%20group%20of%20tough%20characters%20standing%20in%20front%20of%20sports%20cars%2C%20urban%20street%20at%20night%20with%20neon%20lights%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20warm%20amber%20and%20cool%20teal%20tones%2C%20intense%20and%20stylish%20Hollywood%20blockbuster%20style&width=400&height=560&seq=movie-poster-9&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Action%20movie%20backdrop%2C%20fleet%20of%20sports%20cars%20racing%20through%20neon-lit%20city%20streets%20at%20night%2C%20motion%20blur%2C%20dramatic%20lighting%20with%20warm%20amber%20street%20lights%2C%20rain%20on%20asphalt%2C%20high%20energy%2C%20cinematic%20wide%20angle%2C%20Hollywood%20blockbuster%20style&width=1600&height=700&seq=movie-backdrop-9&orientation=landscape",
    tags: ["动作", "飙车", "犯罪"],
    isNew: false,
    isHot: true,
    isFeatured: false,
    views: 1890000,
  },
  {
    id: "movie-10",
    title: "疯狂的外星人2：星际来客",
    titleEn: "Crazy Alien 2: Star Visitor",
    category: "喜剧片",
    categorySlug: "comedy",
    year: 2026,
    rating: 8.4,
    duration: "110分钟",
    region: "中国大陆",
    director: "宁浩",
    actors: ["黄渤", "沈腾", "徐峥", "王宝强"],
    description: "又一个外星人造访地球，这次他遇到了一群更不靠谱的地球人。",
    longDescription: "《疯狂的外星人2：星际来客》延续了宁浩导演的荒诞喜剧风格。一位来自高等文明的外星使者意外坠落在中国的某个小镇上，被一群各怀心思的小人物发现后，上演了一场令人捧腹的闹剧。黄渤和沈腾的黄金喜剧搭档再次点燃笑点，影片在荒诞搞笑的同时也暗含着对人性与文明的深刻思考。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20funny%20alien%20creature%20interacting%20with%20bewildered%20Chinese%20man%20in%20small%20town%20setting%2C%20bright%20and%20colorful%2C%20warm%20yellow%20tones%2C%20playful%20and%20humorous%20style%2C%20exaggerated%20expressions%2C%20clean%20and%20simple%20background&width=400&height=560&seq=movie-poster-10&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Comedy%20movie%20backdrop%2C%20quirky%20Chinese%20small%20town%20street%20with%20unusual%20alien%20spacecraft%20crash-landed%20in%20the%20middle%2C%20bright%20sunny%20day%2C%20warm%20cheerful%20colors%2C%20whimsical%20and%20humorous%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-backdrop-10&orientation=landscape",
    tags: ["喜剧", "科幻", "荒诞"],
    isNew: true,
    isHot: false,
    isFeatured: false,
    views: 832000,
  },
  {
    id: "movie-11",
    title: "少年的你2：未来可期",
    titleEn: "Better Days 2: Bright Future",
    category: "剧情片",
    categorySlug: "drama",
    year: 2026,
    rating: 9.1,
    duration: "122分钟",
    region: "中国大陆",
    director: "曾国祥",
    actors: ["易烊千玺", "周冬雨", "刘昊然"],
    description: "高考结束后的那个夏天，三个年轻人的命运再次交织在一起。",
    longDescription: "《少年的你2：未来可期》是口碑佳作《少年的你》的续篇。故事聚焦高考结束后那个特殊的夏天，陈念和小北各自踏上了新的人生旅程。然而命运似乎总是喜欢开玩笑，一桩意外的发生让两人再次卷入了一场风波。影片以细腻的镜头语言描绘了当代中国年轻人的成长困境与奋斗精神。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20youth%20drama%20movie%20poster%2C%20two%20young%20people%20sitting%20on%20rooftop%20overlooking%20city%20at%20dusk%2C%20warm%20golden%20hour%20lighting%2C%20contemplative%20and%20emotional%20atmosphere%2C%20urban%20landscape%2C%20realistic%20and%20intimate%20style&width=400&height=560&seq=movie-poster-11&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Youth%20drama%20movie%20backdrop%2C%20Chinese%20high%20school%20campus%20at%20sunset%2C%20students%20walking%20on%20tree-lined%20path%2C%20warm%20golden%20sunlight%20filtering%20through%20leaves%2C%20nostalgic%20and%20hopeful%20atmosphere%2C%20cinematic%20shallow%20depth%20of%20field&width=1600&height=700&seq=movie-backdrop-11&orientation=landscape",
    tags: ["剧情", "青春", "成长"],
    isNew: false,
    isHot: false,
    isFeatured: false,
    views: 621000,
  },
  {
    id: "movie-12",
    title: "鬼吹灯之昆仑神宫",
    titleEn: "Mojin: The Kunlun Shrine",
    category: "动作片",
    categorySlug: "action",
    year: 2026,
    rating: 8.6,
    duration: "130分钟",
    region: "中国大陆",
    director: "乌尔善",
    actors: ["陈坤", "黄渤", "舒淇", "夏雨"],
    description: "摸金校尉再出发，深入昆仑山脉探寻传说中的神宫秘宝。",
    longDescription: "《鬼吹灯之昆仑神宫》改编自天下霸唱同名小说，讲述了胡八一、王胖子和Shirley杨组成的摸金三人组，为了寻找传说中的雮尘珠，深入青藏高原昆仑山脉腹地的冒险故事。在万年冰川和古老遗迹中，他们遭遇了无数诡异离奇的生物和致命的机关陷阱。影片将东方神秘文化与现代视觉特效完美融合，打造出一场惊心动魄的古墓探险之旅。",
    posterUrl: "https://readdy.ai/api/search-image?query=Chinese%20adventure%20movie%20poster%2C%20three%20explorers%20standing%20before%20ancient%20mystical%20temple%20entrance%20in%20snowy%20mountains%2C%20mysterious%20golden%20light%20emanating%20from%20within%2C%20dramatic%20lighting%2C%20epic%20fantasy%20adventure%20atmosphere%2C%20warm%20amber%20and%20cool%20white%20tones&width=400&height=560&seq=movie-poster-12&orientation=portrait",
    backdropUrl: "https://readdy.ai/api/search-image?query=Adventure%20movie%20backdrop%2C%20majestic%20snow-capped%20Kunlun%20mountain%20range%20at%20golden%20hour%2C%20ancient%20ruins%20half-buried%20in%20snow%20and%20ice%2C%20dramatic%20cloud%20formations%2C%20epic%20scale%2C%20mysterious%20and%20adventurous%20atmosphere%2C%20cinematic%20landscape&width=1600&height=700&seq=movie-backdrop-12&orientation=landscape",
    tags: ["动作", "冒险", "奇幻"],
    isNew: false,
    isHot: true,
    isFeatured: true,
    views: 1450000,
  },
];

export const reviews = [
  { id: 1, name: "电影爱好者小王", rating: 5, content: "光棍影院的片源真的很全，高清画质看得很过瘾，而且完全免费，强烈推荐！", date: "2026-07-28" },
  { id: 2, name: "追剧达人小李", rating: 5, content: "更新速度超快，新上映的大片基本都能第一时间看到，已经推荐给身边所有朋友了。", date: "2026-07-25" },
  { id: 3, name: "影评人老张", rating: 4, content: "界面简洁易用，分类清晰，找片很方便。片源质量也很稳定，是个良心网站。", date: "2026-07-22" },
  { id: 4, name: "学生党小陈", rating: 5, content: "作为学生党，光棍影院真的是福利！不花钱就能看各种大片，学习之余放松一下太合适了。", date: "2026-07-20" },
  { id: 5, name: "家庭影院爱好者", rating: 5, content: "一家人周末聚在一起看电影已经成了习惯，光棍影院的片库真的很丰富，老少皆宜。", date: "2026-07-18" },
  { id: 6, name: "资深影迷阿强", rating: 4, content: "收藏了很多经典老片，这对于怀旧党来说简直是无价之宝。希望继续保持更新！", date: "2026-07-15" },
];

export const faqs = [
  { question: "光棍影院的电影资源是否免费？", answer: "是的，光棍影院所有电影资源完全免费在线观看，无需注册会员，无需任何付费即可畅享海量高清影视内容。" },
  { question: "光棍影院支持哪些设备观看？", answer: "光棍影院支持电脑、平板、手机等多种设备在线观看，浏览器打开即可，无需下载任何软件或插件。" },
  { question: "电影更新速度快吗？", answer: "光棍影院拥有专业的资源更新团队，每日更新最新上映的电影资源，热门大片和经典佳作同步上线，让您第一时间看到想看的电影。" },
  { question: "电影画质怎么样？", answer: "光棍影院提供高清1080P和超清4K等多种画质选择，观影体验流畅清晰，让您在家也能享受影院级别的视觉盛宴。" },
  { question: "如何找到想看的电影？", answer: "您可以通过首页的分类导航、搜索功能，或者浏览不同电影类型分类页面来快速找到想看的电影。我们提供了动作片、喜剧片、科幻片等多个分类方便您筛选。" },
  { question: "观看电影需要注册账号吗？", answer: "不需要！光棍影院无需注册即可免费观看所有电影，打开网站就能直接观看，方便快捷。" },
];